import { render, staticRenderFns } from "./ReviewEditModal.vue?vue&type=template&id=0abecda8"
import script from "./ReviewEditModal.vue?vue&type=script&lang=js"
export * from "./ReviewEditModal.vue?vue&type=script&lang=js"
import style0 from "./ReviewEditModal.vue?vue&type=style&index=0&id=0abecda8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports